import { assignInlineVars } from '@vanilla-extract/dynamic';
import clsx from 'clsx';
import React, { ReactNode } from 'react';

import { roundFloat } from '@utils/round';

import {
	chartClass,
	chartContainerClass,
	chartImgUrl,
	chartValue,
	chartWrapperClass,
	containerClass,
	displayTitleClass,
	displayTitleContainerClass,
	displayTitleDotClass,
	displayTitleStrokeClass,
	grayScaleClass,
	innerClass,
} from './style.css';
import ColoredChartText from '../colored-chart-text/ColoredChartText';

export interface TriangleChartProps {
	desc?: ReactNode;
	subDesc?: string;
	valuePercentage?: number;
	size?: 'small' | 'medium';
	graphAlign?: 'left' | 'center' | 'right';
	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const TriangleChart = ({
	desc,
	subDesc,
	size = 'medium',
	graphAlign = 'center',
	isLoading,
	isError,
	lackOfPermission,
	...props
}: TriangleChartProps) => {
	const valuePercentage = lackOfPermission ? 60 : props.valuePercentage ?? undefined;

	const tiers = ['first', 'second', 'third', 'fourth'] as const;
	const currentTier = valuePercentage
		? valuePercentage >= 100
			? tiers[3]
			: tiers[Math.floor(valuePercentage / 25)]
		: undefined;

	type Tier = (typeof tiers)[number];

	const TierImgUrlMapper: Record<Tier, string> = {
		first: `url(/report/triangle-graph-1.svg)`,
		second: `url(/report/triangle-graph-2.svg)`,
		third: `url(/report/triangle-graph-3.svg)`,
		fourth: `url(/report/triangle-graph-4.svg)`,
	};

	return (
		<div className={containerClass}>
			{desc && (
				<ColoredChartText
					subText={subDesc}
					isLoading={isLoading}
					isError={isError}
					lackOfPermission={lackOfPermission}
				>
					{desc}
				</ColoredChartText>
			)}

			<div className={chartContainerClass({ align: graphAlign })}>
				<div className={innerClass}>
					<div
						className={
							isLoading || isError
								? clsx(grayScaleClass, chartWrapperClass)
								: chartWrapperClass
						}
					>
						<div
							className={chartClass({ size })}
							style={assignInlineVars({
								[chartImgUrl]: currentTier ? TierImgUrlMapper[currentTier] : undefined,
							})}
						/>
						{/* <TriangleGraph /> */}
					</div>

					{!isLoading && !isError && (
						<div
							className={displayTitleDotClass}
							style={assignInlineVars({
								[chartValue]: valuePercentage ? `${valuePercentage}%` : '50%',
							})}
						>
							<div className={displayTitleContainerClass}>
								<div className={displayTitleStrokeClass({ size })} />
								<div className={displayTitleClass}>
									상위{' '}
									{lackOfPermission
										? '00'
										: valuePercentage
										? roundFloat(valuePercentage, 'down', 2)
										: '-'}
									%
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default TriangleChart;
